import React from "react";
import "./App.css";
import { AuthProvider } from "./app/contexts/JWTAuthContext";
import { VoiceProvider } from "./app/contexts/VoiceContext";
import RoutePage from "./features/config/routes/RoutePage";
import { ErrorProvider } from "./features/components/customComponents/Error/ErrorContext";
import GlobalErrorHandler from "./features/components/customComponents/Error/GlobalErrorHandler";
import AxiosInterceptorProvider from "./features/components/customComponents/Error/AxiosInterceptorProvider";
import GlobalComponent from "./features/components/customComponents/GlobalComponent/GlobalComponent";

function App() {
  return (
    <AuthProvider>
      <VoiceProvider>
        <ErrorProvider>
          <AxiosInterceptorProvider>
            <RoutePage />
            <GlobalComponent />
            <GlobalErrorHandler />
          </AxiosInterceptorProvider>
        </ErrorProvider>
      </VoiceProvider>
    </AuthProvider>
  );
}

export default App;
